import { Placeholder } from '@goodrx/matisse';
import { useSynapse } from 'app/lib/synaptik';
import React, { FC } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

type UnauthenticatedRouteProps = RouteProps;

/**
 * This component is for pages like Login, Forgot Password, etc.
 * If logged in, they are inaccessible.
 */
export const UnauthenticatedRoute: FC<UnauthenticatedRouteProps> = ({
  component: Component,
  ...routeProps
}: UnauthenticatedRouteProps) => {
  const [reauthenticating, authenticated] = useSynapse(({ user }) => [
    user.state.reauthenticating,
    user.state.authenticated,
  ]);

  return (
    <Route
      {...routeProps}
      render={(props) => (
        <Placeholder loading={reauthenticating}>
          {() =>
            authenticated ? <Redirect to={{ pathname: '/account' }} /> : Component ? <Component {...props} /> : null
          }
        </Placeholder>
      )}
    />
  );
};
